/* eslint-disable no-param-reassign */
import { combineReducers } from 'redux'
import createReducer from './createReducer'
import { keyify } from '../utils'

const admin = createReducer(null, {
  FETCH_ADMIN_SUCCESS: (state, action) => action.payload,

  REMOVE_C_TERMINAL_FINISHED: (state, action) => {
    if (state.user.subadmins) {
      state.user.subadmins.forEach((s) => {
        s.terminals = s.terminals.filter((t) => t !== action.payload)
      })
    }
  },

  // SUBADMINS
  CREATING_SUBADMIN_FINISHED: (state, action) => {
    state.user.subadmins.push(action.payload)
  },
  UPDATE_SUBADMIN_FINISHED: (state, action) => {
    const { subadmin } = action.payload

    state.user.subadmins = JSON.parse(JSON.stringify(state.user.subadmins)).map((s) => (s._id === subadmin._id ? subadmin : s))
  },
  REMOVE_SUBADMIN_FINISHED: (state, action) => {
    state.user.subadmins = state.user.subadmins.filter((s) => s._id !== action.payload)
  },
})

const carriers = createReducer([], {
  FETCH_CARRIERS_SUCCESS: (state, action) => action.payload,
  CREATE_CARRIER_SUCCESS: (state, action) => state.concat(action.payload),
})

const controllers = createReducer([], {
  FETCH_CONTROLLERS_SUCCESS: (state, action) => action.payload,
})

const customers = createReducer([], {
  FETCH_CUSTOMERS_SUCCESS: (state, action) => action.payload,
  SUBMIT_LOCKSANDUSERS_SUCCESS: (state, action) => {
    for (const customer of action.payload.customers || []) {
      const existingIdx = state.findIndex((c) => c._id === customer._id)

      if (existingIdx > -1) state[existingIdx] = customer
      else state.push(customer)
    }
  },
})

const customersLoaded = createReducer(false, {
  FETCH_CUSTOMERS_SUCCESS: (state, action) => true,
})

const keyedCustomers = createReducer(null, {
  FETCH_CUSTOMERS_SUCCESS: (state, action) => keyify(action.payload, '_id'),
  SUBMIT_LOCKSANDUSERS_SUCCESS: (state, action) => {
    // return keyify(JSON.parse(JSON.stringify(action.payload.customers)), '_id')
  },
})

const companies = (state = {}, action) => {
  const newState = { ...state }

  switch (action.type) {
    case 'FETCH_COMPANIES_SUCCESS': {
      const keyedCompanies = action.payload.reduce((acc, val) => {
        acc[val._id] = val
        return acc
      }, {})

      newState.companies = action.payload
      newState.keyedCompanies = keyedCompanies
      return newState
    }
    case 'CREATE_COMPANY_FINISHED': {
      newState.companies = action.payload.data
      return newState
    }
  }

  return newState
}

const keyedCompanies = createReducer(
  {},
  {
    FETCH_COMPANIES_SUCCESS: (state, action) => keyify(action.payload, '_id'),
  }
)

const companiesLoaded = createReducer(false, {
  FETCH_COMPANIES_SUCCESS: (state, action) => true,
})

const deliveries = (state = [], action) => {
  let newState = [...state]

  switch (action.type) {
    case 'FETCH_DELIVERIES_SUCCESS':
      if (!action.query || action.query.page === 0) {
        newState = action.payload
      } else {
        newState = newState.concat(action.payload)
      }

      return newState

    case 'FETCH_DELIVERIES_DOCUMENTS_SUCCESS':
      for (const delivery of action.payload) {
        if (!newState.find((d) => d._id === delivery._id)) newState.push(delivery)
      }

      return newState

    case 'DELIVERIES_PROPERTIES_UPDATED':
      newState = newState.map((delivery) => {
        for (const d of action.payload) {
          if (delivery._id === d._id) return { ...delivery, ...d }
        }

        return delivery
      })

    case 'DELIVERY_STATUS_UPDATED':
      newState = newState.map((delivery) => {
        if (delivery._id === action.payload._id) return { ...delivery, qsignReason: action.payload.qsignReason, qsign: action.payload.qsign }

        return delivery
      })

    case 'DELIVERY_DELETED':
      newState = newState.filter((delivery) => !action.payload.deliveryIds.includes(delivery._id))
  }

  return newState
}

const deliveriesLoaded = createReducer(false, {
  FETCH_DELIVERIES_SUCCESS: (state, action) => true,
})

const drivers = createReducer([], {
  FETCH_DRIVERS_SUCCESS: (state, action) => action.payload,
  // TODO: HANDLE SUCCESS IN ACTION
  REMOVE_DRIVER_FINISHED: (state, action) => state.filter((driver) => driver._id !== action.payload),
  CREATING_DRIVER_FINISHED: (state, action) => state.concat(action.payload),
  UPDATE_DRIVER_FINISHED: (state, action) => {
    state.forEach((driver, i) => {
      if (driver._id === action.payload._id) {
        state[i] = action.payload
      }
    })
  },
  // TODO: HANDLE FAILURE IN ACTION for CREATING_DRIVER_ERROR
  SUBMIT_DRIVER_SUCCESSFUL: (state, action) => {
    state.forEach((driver) => {
      if (driver._id === action.payload.id) {
        Object.entries(action.payload.change).forEach(([key, val]) => {
          driver[key] = val
        })
      }
    })
  },
  REMOVE_C_TERMINAL_FINISHED: (state, action) => {
    const newState = []
    state.forEach((d) => {
      const driver = Object.entries(d).reduce(
        (acc, [key, value]) => ({
          ...acc,
          [key]: value,
        }),
        {}
      )
      if (driver.terminal !== action.payload) newState.push(driver)
    })
    return newState
  },
})

const easy_accesses = createReducer([], {
  INACTIVATE_EASYACCESSES_SUCCESS: (state, action) => {
    console.log(JSON.parse(JSON.stringify(state)))
    state.forEach((ea, i) => {
      if (action.payload.find((id) => id === ea._id)) state[i].active = false
    })
  },
  FETCH_EASYACCESSES_SUCCESS: (state, action) => action.payload,
  SUBMIT_EASYACCESS_SUCCESS: (state, action) => state.concat(action.payload),
  REMOVE_EASYACCESS_SUCCESS: (state, action) => {
    state.forEach((ea) => {
      ea.active = ea._id !== action.payload.id
    })
  },
  ALLOCATE_SUCCESS: (state, action) => state.concat(action.payload.easy_access),
  CREATING_EASYACCESSES_WITH_RECEIVERLIST_FINISHED: (state, action) => state.concat(action.payload.easy_accesses),
})

const events = (state = [], action) => {
  const newState = [...state]

  switch (action.type) {
    case 'FETCH_EVENTS_SUCCESS': {
      for (const event of action.payload) {
        if (!state.find((stateEvent) => stateEvent._id === event._id)) newState.push(event)
      }
    }
  }

  return newState
}

const messageGroups = createReducer(
  {},
  {
    GET_MESSAGEGROUPS_SUCCESS: (state, action) => {
      state[action.payload.lockId] = action.payload.messageGroups
    },
  }
)

const locks = createReducer([], {
  FETCH_LOCKS_SUCCESS: (state, action) => {
    if (process.env.NODE_ENV === 'production' && localStorage.userType === 'admin') {
      window.Intercom('update', {
        Locks: JSON.stringify(action.payload.reduce((acc, l) => (l.isCarrierDoor ? acc : acc.concat(l.custom_name)), [])),
        language_override: window.navigator.language === 'sv' ? 'sv' : 'en',
      })
    }

    return action.payload
  },
  CREATING_EASYACCESSES_WITH_RECEIVERLIST_FINISHED: (state, action) => {
    state.forEach((lock, i) => {
      if (lock._id === action.payload.lock._id) state[i] = action.payload.lock
    })
  },
  REMOVE_MESSAGEGROUPS_ACCESSES_SUCCESS: (state, action) => {
    state.forEach((lock, i) => {
      for (const newLock of action.payload) {
        if (lock._id === newLock._id) state[i] = newLock
      }
    })
  },
  ADD_MESSAGEGROUPS_ACCESSES_SUCCESS: (state, action) => {
    state.forEach((lock, i) => {
      if (lock._id === action.payload._id) state[i] = action.payload
    })
    console.log(JSON.parse(JSON.stringify(state)))
  },
  SUBMIT_LOCKSANDUSERS_SUCCESS: (state, action) => {
    state.forEach((lock) => {
      action.payload.locks.forEach((uLock) => {
        if (lock._id === uLock._id) {
          lock.users = uLock.users
        }
      })
    })
  },
  REMOVE_LOCK_ACCESSES_SUCCESS: (state, action) => {
    state.forEach((lock, i) => {
      state[i].users = state[i].users.reduce((acc, user) => {
        for (const accessId of action.payload) {
          if (!accessId.includes('carrierDoor') || accessId.split('-')[0] !== user._id) continue

          return acc.concat({ ...user, carrierDoorAccess: null })
        }

        if (action.payload.includes(user._id)) return acc

        return acc.concat(user)
      }, [])
    })
  },
  UPDATE_LOCK_ACCESS_SUCCESS: (state, action) => {
    const { lockId, accessId, shouldBeContactPerson } = action.payload

    state.forEach((lock) => {
      if (lock._id !== lockId) return

      const userToUpdate = lock.users.find((u) => u._id === accessId)

      if (shouldBeContactPerson) {
        userToUpdate.level = 2
        userToUpdate.type = 'contactPerson'
      } else {
        userToUpdate.level = 1
        userToUpdate.type = null
      }
    })
  },
  REMOVE_USER: (state, action) => {
    state.forEach((lock) => {
      lock.users = (lock.users || []).filter((user) => user._id !== action.payload.access_id)
    })
  },
  FETCH_ALLOCATION_DELIVERY_SUCCESS: (state, action) => {
    state.forEach((lock) => {
      if (lock.doors) {
        lock.doors.forEach((door) => {
          if (door.allocation.delivery === action.payload.id) {
            door.allocation.delivery = action.payload
          }
        })
      }
    })
  },
  UNALLOCATE_SUCCESS: (state, action) =>
    state.map((lock) => {
      if (lock._id === action.payload.lock._id) {
        lock = action.payload.lock
      }
      return lock
    }),
  UNALLOCATE_DOOR_SUCCESS: (state, action) => {
    state.map((lock) => {
      if (lock._id === action.payload.lockId) {
        lock.doors.map((d) => (d._id === action.payload.doorId ? (d.allocation = {}) : null))
      }
      return lock
    })
  },
  ALLOCATE_SUCCESS: (state, action) =>
    state.map((lock) => {
      if (lock._id === action.payload.lock._id) {
        lock = action.payload.lock
      }
      return lock
    }),
  DBF_SUCCESS: (state, action) => {
    state.forEach((lock) => {
      if (lock._id === action.payload.lockId) {
        lock.settings.DBF_carriers = action.payload.data
      }
    })
  },
  SAVE_ALT_ADDRESSES_SUCCESS: (state, action) => {
    state.forEach((lock) => {
      if (lock._id === action.payload.lockId) {
        lock.alternative_addresses = action.payload.addresses
      }
    })
  },
  SAVE_GATE_ADDRESSES_SUCCESS: (state, action) => {
    state.forEach((lock) => {
      if (lock._id === action.payload.lockId) {
        lock.gate_addresses = action.payload.addresses
      }
    })
  },
  LOCK_DEACTIVATED: (state, action) => state.filter((lock) => lock._id !== action.payload.lockId),
  CREATE_LOCK_SUCCESS: (state, action) => state.concat(action.payload),
})

const keyedLocks = createReducer(null, {
  FETCH_LOCKS_SUCCESS: (state, action) => keyify(action.payload, '_id'),
})

const rentals = createReducer(null, {
  FETCH_RENTALS_SUCCESS: (state, action) => action.payload,
})

const rental_companies = createReducer([], {
  FETCH_RENTAL_COMPANIES_SUCCESS: (state, action) => action.payload,
})

// TODO: WHATUP WID DIZZ??
const returns = createReducer([], {
  FETCH_RENTALS_SUCCESS: (state, action) => action.payload,
})

const terminals = createReducer([], {
  FETCH_C_TERMINALS_SUCCESS: (state, action) => action.payload,
  CREATING_C_TERMINAL_FINISHED: (state, action) => state.concat(action.payload),
  UPDATE_C_TERMINAL_FINISHED: (state, action) => {
    for (const terminal of state) {
      if (terminal._id === action.payload._id) {
        Object.entries(action.payload).forEach(([key, val]) => {
          terminal[key] = val
        })
        break
      }
    }
  },
  REMOVE_C_TERMINAL_FINISHED: (state, action) => state.filter((t) => t._id !== action.payload),
})

const vendors = createReducer([], {
  FETCH_VENDORS_SUCCESS: (state, action) => action.payload,
  CREATING_VENDOR_FINISHED: (state, action) => state.concat(action.payload),
  UPDATE_VENDOR_FINISHED: (state, action) => {
    for (const vendor of state) {
      if (vendor._id === action.payload._id) {
        Object.entries(action.payload).forEach(([key, val]) => {
          vendor[key] = val
        })
        break
      }
    }
  },
  REMOVE_VENDOR_FINISHED: (state, action) => state.filter((t) => t._id !== action.payload),
  SET_CARRIERMAPPINGS_FINISHED: (state, action) =>
    state.map((vendor) => {
      if (vendor._id === action.payload._id) return action.payload

      return vendor
    }),
  SET_MERGEVENDORS_FINISHED: (state, action) =>
    state
      .map((vendor) => {
        if (vendor._id === action.payload.vendorId) return null

        if (vendor._id === action.payload.originalVendorId) return { ...vendor, tags: vendor.tags.concat(action.payload.tags) }

        return vendor
      })
      .filter((v) => v),
})

const s_sms = createReducer([], {
  FETCH_S_SMS_SUCCESS: (state, action) => action.payload,
})

export default combineReducers({
  admin,
  companies,
  keyedCompanies,
  carriers,
  controllers,
  customers,
  keyedCustomers,
  deliveries,
  drivers,
  easy_accesses,
  events,
  locks,
  keyedLocks,
  rentals,
  rental_companies,
  returns,
  terminals,
  vendors,
  s_sms,
  messageGroups,

  deliveriesLoaded,
  customersLoaded,
  companiesLoaded,
})
